import { supabase } from '../../config/supabaseClient';
import { ENV } from '../../config/env';

export type OrgMemberRole = 'owner' | 'admin' | 'member' | 'sales_manager' | 'sales_rep';

export interface ProjectManagementMember {
  organization_id: string;
  user_id: string;
  role: OrgMemberRole;
  email: string | null;
  full_name: string | null;
  avatar_url: string | null;
}

async function getToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return session.access_token;
}

const API_BASE_URL = `${ENV.API_URL}/api/project-management/members`;

export const pmMembersService = {
  async list(organizationId: string): Promise<{ data: ProjectManagementMember[]; error: any }> {
    try {
      const token = await getToken();
      const queryParams = new URLSearchParams({ organization_id: organizationId });

      const response = await fetch(`${API_BASE_URL}?${queryParams.toString()}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return { data: [], error: result?.error || 'Failed to fetch members' };
      }

      return { data: (result.data || []) as ProjectManagementMember[], error: null };
    } catch (e: any) {
      return { data: [], error: e?.message || 'Network error' };
    }
  },
};

export function getDisplayName(member: ProjectManagementMember | null | undefined): string {
  if (!member) return 'Unassigned';
  return member.full_name || member.email || 'Unknown';
}

export function buildMemberMap(members: ProjectManagementMember[]): Record<string, ProjectManagementMember> {
  return (members || []).reduce((acc, m) => {
    if (m?.user_id) acc[m.user_id] = m;
    return acc;
  }, {} as Record<string, ProjectManagementMember>);
}
